import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ApiVersion_MAY_2026_getInstance1jn2lakqb99ub as ApiVersion_MAY_2026_getInstance,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider } from './Shared7Punches-common-base.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IOvertimeRiskAccessor, 'IOvertimeRiskAccessor');
initMetadataForClass(OvertimeRiskRepository, 'OvertimeRiskRepository', VOID, VOID, [IOvertimeRiskAccessor]);
initMetadataForInterface(IOvertimeRiskRemoteSource, 'IOvertimeRiskRemoteSource', VOID, VOID, VOID, [0, 1]);
initMetadataForCompanion(Companion);
initMetadataForClass(OvertimeRiskRemoteSource, 'OvertimeRiskRemoteSource', VOID, VOID, [IOvertimeRiskRemoteSource], [0, 1]);
//endregion
function OvertimeRiskRepository(remoteSource, sessionDataProvider) {
  this.l88_1 = remoteSource;
  this.m88_1 = sessionDataProvider;
}
function IOvertimeRiskRemoteSource() {
}
function Companion() {
  Companion_instance = this;
  this.n88_1 = ApiVersion_MAY_2026_getInstance();
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function OvertimeRiskRemoteSource(api, sessionDataProvider) {
  Companion_getInstance_0();
  this.o88_1 = api;
  this.p88_1 = sessionDataProvider;
}
function get_overtimeRiskModule() {
  _init_properties_OvertimeRiskModule_kt__u9xwfw();
  return overtimeRiskModule;
}
var overtimeRiskModule;
function overtimeRiskModule$lambda($this$module) {
  _init_properties_OvertimeRiskModule_kt__u9xwfw();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = overtimeRiskModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IOvertimeRiskRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = overtimeRiskModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(OvertimeRiskRepository), null, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  var tmp = new KoinDefinition($this$module, factory_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$9 = [getKClass(IOvertimeRiskAccessor)];
  binds(tmp, tmp$ret$9);
  return Unit_instance;
}
function overtimeRiskModule$lambda$lambda($this$factory, it) {
  _init_properties_OvertimeRiskModule_kt__u9xwfw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new OvertimeRiskRemoteSource(tmp, tmp$ret$1);
}
function overtimeRiskModule$lambda$lambda_0($this$single, it) {
  _init_properties_OvertimeRiskModule_kt__u9xwfw();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IOvertimeRiskRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  return new OvertimeRiskRepository(tmp, tmp$ret$1);
}
var properties_initialized_OvertimeRiskModule_kt_qb2h3y;
function _init_properties_OvertimeRiskModule_kt__u9xwfw() {
  if (!properties_initialized_OvertimeRiskModule_kt_qb2h3y) {
    properties_initialized_OvertimeRiskModule_kt_qb2h3y = true;
    overtimeRiskModule = module_0(VOID, overtimeRiskModule$lambda);
  }
}
function IOvertimeRiskAccessor() {
}
//region block: exports
export {
  get_overtimeRiskModule as get_overtimeRiskModule1y00cf8l5x9k3,
  IOvertimeRiskAccessor as IOvertimeRiskAccessorulrq4mhwwk0i,
};
//endregion

